export function isPartitionedGridModelProvider(model) {
  return (model === null || model === void 0 ? void 0 : model.isPartitionRequired) !== undefined && (model === null || model === void 0 ? void 0 : model.partitionColumns) !== undefined && (model === null || model === void 0 ? void 0 : model.partitionKeysTable) !== undefined && (model === null || model === void 0 ? void 0 : model.partitionMergedTable) !== undefined && (model === null || model === void 0 ? void 0 : model.partitionTable) !== undefined;
}
export function isPartitionedGridModel(model) {
  return isPartitionedGridModelProvider(model) && model.partitionConfig !== undefined;
}

/**
 * A grid model that provides key tables and partitions, cannot accept a `PartitionConfig` being set
 */

/**
 * A grid model that can be partitioned on a column
 */
//# sourceMappingURL=PartitionedGridModel.js.map